module.exports = __webpack_public_path__ + "img/start-presentation.a23ef97e.svg";